// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3Z6Ct","main-image":"Header_main-image__2Em4v"};